import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"
import _imports_0 from '../assets/contact.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "govuk-heading-xl" }, "My Orders", -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "govuk-body-l" }, "Filter your orders using the fields below:", -1)
const _hoisted_4 = { class: "govuk-table__container" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "govuk-heading-l" }, "Active Orders", -1)
const _hoisted_6 = { class: "govuk-table" }
const _hoisted_7 = { class: "govuk-table__head" }
const _hoisted_8 = { class: "govuk-table__row" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "govuk-table__header"
}, "Order Number", -1)
const _hoisted_10 = ["aria-sort"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "govuk-table__header"
}, "Available Until", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "govuk-table__header"
}, "Download Documents", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "govuk-table__header"
}, "Contact us", -1)
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "govuk-table__cell" }
const _hoisted_17 = { class: "govuk-table__cell" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "govuk-table__cell" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { key: 2 }
const _hoisted_25 = { class: "govuk-table__cell" }
const _hoisted_26 = ["onMouseover", "href", "onClick"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("img", {
  width: "20",
  alt: "Contact us",
  src: _imports_0
}, null, -1)
const _hoisted_28 = { class: "hover-message" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "arrow-down" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Contact Us if you would like help with this order")
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = { class: "govuk-table__cell" }
const _hoisted_33 = { class: "govuk-table__cell" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("td", { class: "govuk-table__cell" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("td", { class: "govuk-table__cell" }, null, -1)
const _hoisted_37 = {
  "aria-live": "polite",
  role: "status",
  "aria-atomic": "true",
  class: "govuk-visually-hidden"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("h2", { class: "govuk-heading-l" }, "Expired Orders", -1)
const _hoisted_39 = { class: "govuk-table" }
const _hoisted_40 = { class: "govuk-table__head" }
const _hoisted_41 = { class: "govuk-table__row" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "govuk-table__header"
}, "Order Number", -1)
const _hoisted_43 = ["aria-sort"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "govuk-table__header"
}, "Available Until", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "govuk-table__header"
}, "Download Documents", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "govuk-table__header"
}, "Contact us", -1)
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { class: "govuk-table__cell" }
const _hoisted_50 = { class: "govuk-table__cell" }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { class: "govuk-table__cell" }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = ["onClick"]
const _hoisted_55 = ["onClick"]
const _hoisted_56 = { key: 1 }
const _hoisted_57 = { key: 2 }
const _hoisted_58 = { class: "govuk-table__cell" }
const _hoisted_59 = ["href", "onClick"]
const _hoisted_60 = /*#__PURE__*/_createElementVNode("img", {
  width: "20",
  alt: "Contact us",
  src: _imports_0
}, null, -1)
const _hoisted_61 = [
  _hoisted_60
]
const _hoisted_62 = { class: "govuk-table__cell" }
const _hoisted_63 = { class: "govuk-table__cell" }
const _hoisted_64 = { key: 0 }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("td", { class: "govuk-table__cell" }, null, -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("td", { class: "govuk-table__cell" }, null, -1)
const _hoisted_67 = {
  "aria-live": "polite",
  role: "status",
  "aria-atomic": "true",
  class: "govuk-visually-hidden"
}
const _hoisted_68 = {
  key: 1,
  class: "moj-pagination",
  id: "pagination-label"
}
const _hoisted_69 = /*#__PURE__*/_createElementVNode("p", {
  class: "govuk-visually-hidden",
  "aria-labelledby": "pagination-label"
}, "Pagination navigation", -1)
const _hoisted_70 = { class: "moj-pagination__list" }
const _hoisted_71 = { class: "moj-pagination__item moj-pagination__item--prev" }
const _hoisted_72 = /*#__PURE__*/_createTextVNode("Previous")
const _hoisted_73 = /*#__PURE__*/_createElementVNode("span", { class: "govuk-visually-hidden" }, " set of pages", -1)
const _hoisted_74 = [
  _hoisted_72,
  _hoisted_73
]
const _hoisted_75 = ["onClick"]
const _hoisted_76 = {
  key: 0,
  class: "moj-pagination__link",
  href: "#"
}
const _hoisted_77 = { key: 1 }
const _hoisted_78 = { class: "moj-pagination__item moj-pagination__item--next" }
const _hoisted_79 = /*#__PURE__*/_createTextVNode("Next")
const _hoisted_80 = /*#__PURE__*/_createElementVNode("span", { class: "govuk-visually-hidden" }, " set of pages", -1)
const _hoisted_81 = [
  _hoisted_79,
  _hoisted_80
]
const _hoisted_82 = { class: "moj-pagination__results" }
const _hoisted_83 = /*#__PURE__*/_createTextVNode("Showing ")
const _hoisted_84 = /*#__PURE__*/_createTextVNode(" to ")
const _hoisted_85 = /*#__PURE__*/_createTextVNode(" of ")
const _hoisted_86 = /*#__PURE__*/_createTextVNode(" results")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Form = _resolveComponent("Form")!
  const _component_Tabs = _resolveComponent("Tabs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_ctx.data.entries)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_Form, {
            fieldsets: _ctx.fieldsets,
            fields: _ctx.fields,
            onFormFieldValuesUpdated: _ctx.filterOrders
          }, null, 8, ["fieldsets", "fields", "onFormFieldValuesUpdated"]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Tabs, { tabs: _ctx.tabs }, {
              "active-orders": _withCtx(() => [
                _hoisted_5,
                _createElementVNode("table", _hoisted_6, [
                  _createElementVNode("thead", _hoisted_7, [
                    _createElementVNode("tr", _hoisted_8, [
                      _hoisted_9,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, name) => {
                        return (_openBlock(), _createElementBlock("th", {
                          key: name,
                          scope: "col",
                          class: "govuk-table__header",
                          "aria-sort": (_ctx.sortColumn === name ? _ctx.sortDirection : 'none')
                        }, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.sortBy(name, 'ascending', column.label)),
                            type: "button"
                          }, _toDisplayString(column.label), 9, _hoisted_11)
                        ], 8, _hoisted_10))
                      }), 128)),
                      _hoisted_12,
                      _hoisted_13,
                      _hoisted_14
                    ])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeOrders, (entry, index) => {
                    return (_openBlock(), _createElementBlock("tbody", {
                      class: "govuk-table__body",
                      key: index
                    }, [
                      _createElementVNode("tr", {
                        class: _normalizeClass(_ctx.getParentHiddenRowClassList(entry)),
                        onClick: ($event: any) => (_ctx.showHiddenRows(entry))
                      }, [
                        _createElementVNode("td", _hoisted_16, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.getFromOrderState(entry, 'orderNumber')), 1)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, name) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: name,
                            class: "govuk-table__cell"
                          }, _toDisplayString(_ctx.getFormattedColumnValue(entry.properties[name], column.type)), 1))
                        }), 128)),
                        _createElementVNode("td", _hoisted_17, [
                          (_ctx.getFromOrderState(entry, 'itemAvailableUntilDate') !== '')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.getFormattedColumnValue(_ctx.getFromOrderState(entry, 'itemAvailableUntilDate'), 'date')), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_19, [
                          (_ctx.documentsCanBeDownloaded(entry) && !_ctx.documentsExpired(entry))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                                (_ctx.grantCanBeDownloaded(entry))
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      class: "govuk-link",
                                      href: "#",
                                      onClick: _withModifiers(($event: any) => (_ctx.downloadDocuments(entry, 'grant')), ["stop","prevent"])
                                    }, " Download Grant ", 8, _hoisted_21))
                                  : _createCommentVNode("", true),
                                (_ctx.willCanBeDownloaded(entry))
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 1,
                                      class: "govuk-link",
                                      href: "#",
                                      onClick: _withModifiers(($event: any) => (_ctx.downloadDocuments(entry, 'will')), ["stop","prevent"])
                                    }, " Download Will ", 8, _hoisted_22))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_ctx.documentsExpired(entry))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_23, "Documents expired"))
                              : (_openBlock(), _createElementBlock("span", _hoisted_24, "Documents pending"))
                        ]),
                        _createElementVNode("td", _hoisted_25, [
                          (_ctx.getContactOrderHref(entry) !== '')
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                onMouseover: ($event: any) => (_ctx.hoverMessageIndex = index),
                                onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (_ctx.hoverMessageIndex = null)),
                                class: "govuk-link",
                                href: _ctx.getContactOrderHref(entry),
                                onClick: _withModifiers(($event: any) => (_ctx.getContactOrderHref(entry)), ["stop"])
                              }, [
                                _hoisted_27,
                                _withDirectives(_createElementVNode("span", _hoisted_28, _hoisted_31, 512), [
                                  [_vShow, _ctx.hoverMessageIndex === index]
                                ])
                              ], 40, _hoisted_26))
                            : _createCommentVNode("", true)
                        ])
                      ], 10, _hoisted_15),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry.properties['hmctsgrant:ordersState'], (orderState, orderStateIndex) => {
                        return _withDirectives((_openBlock(), _createElementBlock("tr", {
                          class: _normalizeClass(_ctx.getHiddenRowClassList(entry.uid)),
                          key: orderStateIndex
                        }, [
                          _createElementVNode("td", _hoisted_32, [
                            _createElementVNode("span", null, _toDisplayString(orderState.orderNumber), 1)
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, name) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: name,
                              class: "govuk-table__cell"
                            }, _toDisplayString(_ctx.getFormattedColumnValue(entry.properties[name], column.type)), 1))
                          }), 128)),
                          _createElementVNode("td", _hoisted_33, [
                            (_ctx.getFromOrderState(entry, 'itemAvailableUntilDate') !== '')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_ctx.getFormattedColumnValue(_ctx.getFromOrderState(entry, 'itemAvailableUntilDate'), 'date')), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _hoisted_35,
                          _hoisted_36
                        ], 2)), [
                          [_vShow, _ctx.customerOrderNumbers.includes(orderState.orderNumber)]
                        ])
                      }), 128))
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.sortStatusMessage), 1)
              ]),
              "expired-orders": _withCtx(() => [
                _hoisted_38,
                _createElementVNode("table", _hoisted_39, [
                  _createElementVNode("thead", _hoisted_40, [
                    _createElementVNode("tr", _hoisted_41, [
                      _hoisted_42,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, name) => {
                        return (_openBlock(), _createElementBlock("th", {
                          key: name,
                          scope: "col",
                          class: "govuk-table__header",
                          "aria-sort": (_ctx.sortColumn === name ? _ctx.sortDirection : 'none')
                        }, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.sortBy(name, 'ascending', column.label)),
                            type: "button"
                          }, _toDisplayString(column.label), 9, _hoisted_44)
                        ], 8, _hoisted_43))
                      }), 128)),
                      _hoisted_45,
                      _hoisted_46,
                      _hoisted_47
                    ])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expiredOrders, (entry, index) => {
                    return (_openBlock(), _createElementBlock("tbody", {
                      class: "govuk-table__body",
                      key: index
                    }, [
                      _createElementVNode("tr", {
                        class: _normalizeClass(_ctx.getParentHiddenRowClassList(entry)),
                        onClick: ($event: any) => (_ctx.showHiddenRows(entry))
                      }, [
                        _createElementVNode("td", _hoisted_49, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.getFromOrderState(entry, 'orderNumber')), 1)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, name) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: name,
                            class: "govuk-table__cell"
                          }, _toDisplayString(_ctx.getFormattedColumnValue(entry.properties[name], column.type)), 1))
                        }), 128)),
                        _createElementVNode("td", _hoisted_50, [
                          (_ctx.getFromOrderState(entry, 'itemAvailableUntilDate') !== '')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(_ctx.getFormattedColumnValue(_ctx.getFromOrderState(entry, 'itemAvailableUntilDate'), 'date')), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_52, [
                          (_ctx.documentsCanBeDownloaded(entry) && !_ctx.documentsExpired(entry))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_53, [
                                (_ctx.grantCanBeDownloaded(entry))
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      class: "govuk-link",
                                      href: "#",
                                      onClick: _withModifiers(($event: any) => (_ctx.downloadDocuments(entry, 'grant')), ["stop","prevent"])
                                    }, " Download Grant ", 8, _hoisted_54))
                                  : _createCommentVNode("", true),
                                (_ctx.willCanBeDownloaded(entry))
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 1,
                                      class: "govuk-link",
                                      href: "#",
                                      onClick: _withModifiers(($event: any) => (_ctx.downloadDocuments(entry, 'will')), ["stop","prevent"])
                                    }, " Download Will ", 8, _hoisted_55))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_ctx.documentsExpired(entry))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_56, "Documents expired"))
                              : (_openBlock(), _createElementBlock("span", _hoisted_57, "Documents pending"))
                        ]),
                        _createElementVNode("td", _hoisted_58, [
                          (_ctx.getContactOrderHref(entry) !== '')
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                class: "govuk-link",
                                href: _ctx.getContactOrderHref(entry),
                                onClick: _withModifiers(($event: any) => (_ctx.getContactOrderHref(entry)), ["stop"])
                              }, _hoisted_61, 8, _hoisted_59))
                            : _createCommentVNode("", true)
                        ])
                      ], 10, _hoisted_48),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry.properties['hmctsgrant:ordersState'], (orderState, orderStateIndex) => {
                        return _withDirectives((_openBlock(), _createElementBlock("tr", {
                          class: _normalizeClass(_ctx.getHiddenRowClassList(entry.uid)),
                          key: orderStateIndex
                        }, [
                          _createElementVNode("td", _hoisted_62, [
                            _createElementVNode("span", null, _toDisplayString(orderState.orderNumber), 1)
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, name) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: name,
                              class: "govuk-table__cell"
                            }, _toDisplayString(_ctx.getFormattedColumnValue(entry.properties[name], column.type)), 1))
                          }), 128)),
                          _createElementVNode("td", _hoisted_63, [
                            (_ctx.getFromOrderState(entry, 'itemAvailableUntilDate') !== '')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_64, _toDisplayString(_ctx.getFormattedColumnValue(_ctx.getFromOrderState(entry, 'itemAvailableUntilDate'), 'date')), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _hoisted_65,
                          _hoisted_66
                        ], 2)), [
                          [_vShow, _ctx.customerOrderNumbers.includes(orderState.orderNumber)]
                        ])
                      }), 128))
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.sortStatusMessage), 1)
              ]),
              _: 1
            }, 8, ["tabs"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.data.numberOfPages > 1)
      ? (_openBlock(), _createElementBlock("nav", _hoisted_68, [
          _hoisted_69,
          _createElementVNode("ul", _hoisted_70, [
            _createElementVNode("li", _hoisted_71, [
              (!_ctx.isFirstPage)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "moj-pagination__link",
                    href: "#",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)), ["prevent"]))
                  }, _hoisted_74))
                : _createCommentVNode("", true)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginationPages, (page) => {
              return (_openBlock(), _createElementBlock("li", {
                key: page,
                onClick: _withModifiers(($event: any) => (_ctx.goToPage(page)), ["prevent"]),
                class: _normalizeClass({ 'moj-pagination__item': true, 'moj-pagination__item--active': _ctx.currentPageNumber === page })
              }, [
                (_ctx.currentPageNumber !== page)
                  ? (_openBlock(), _createElementBlock("a", _hoisted_76, _toDisplayString(page), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_77, _toDisplayString(page), 1))
              ], 10, _hoisted_75))
            }), 128)),
            _createElementVNode("li", _hoisted_78, [
              (!_ctx.isLastPage)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "moj-pagination__link",
                    href: "#",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)), ["prevent"]))
                  }, _hoisted_81))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("p", _hoisted_82, [
            _hoisted_83,
            _createElementVNode("b", null, _toDisplayString(_ctx.data.currentPageOffset), 1),
            _hoisted_84,
            _createElementVNode("b", null, _toDisplayString(_ctx.data.currentPageOffset + _ctx.data.currentPageSize), 1),
            _hoisted_85,
            _createElementVNode("b", null, _toDisplayString(_ctx.numberOfResults), 1),
            _hoisted_86
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}